<template>
  <div style="text-align: center;margin-bottom: 600px">
    智慧能源
  </div>
</template>

<script>
export default {
  name: "energy",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>

</style>